import React from "react";
import "./JoinFundraiser.css";
import JoinFundraiserForm from "../../components/Forms/JoinFundraiserForm";

const ParticipantJoinFundraiser = () => {
  return (
    <div className="particpant-join-fundraiser-page-wrapper">
      <JoinFundraiserForm />
    </div>
  );
};

export default ParticipantJoinFundraiser;
